import React from 'react';
import { Box, Spinner, TableBody, TableCell, TableRow, Text } from '@razorpay/blade/components';

export const ListViewLoader = ({
  columnCount,
  accessibilityLabel = 'loading list items',
  height = '378px',
}: {
  columnCount: number;
  accessibilityLabel?: string;
  height?: string;
}) => {
  // Calculate which column should contain the loader
  // For odd columns, use the exact center; for even columns, use the second half's first column
  const middleColumnIndex = Math.floor((columnCount - 1) / 2);
  const emptyColumnsBefore = middleColumnIndex;
  const emptyColumnsAfter = columnCount - middleColumnIndex - 1;

  return (
    <TableBody>
      <TableRow item={{ id: 'loading' }}>
        {Array(emptyColumnsBefore)
          .fill(0)
          .map((_, index) => (
            <TableCell key={`empty-before-${index}`}>
              <Box />
            </TableCell>
          ))}
        <TableCell>
          <Box
            height={height as any}
            display={'flex'}
            width={'100%'}
            alignItems={'center'}
            justifyContent={'center'}
            flexDirection={'row'}
            gap="spacing.3">
            <Spinner accessibilityLabel={accessibilityLabel} />
            <Text>Loading...</Text>
          </Box>
        </TableCell>
        {Array(emptyColumnsAfter)
          .fill(0)
          .map((_, index) => (
            <TableCell key={`empty-after-${index}`}>
              <Box />
            </TableCell>
          ))}
      </TableRow>
    </TableBody>
  );
};
